export type LocalSaleStatus = "ERROR" | "LOCAL" | "ONGOING" | "SUBMITTING";
export enum LOCAL_SALE_STATUSES {
  LOCAL = "LOCAL",
  ONGOING = "ONGOING",
  SUBMITTING = "SUBMITTING",
  ERROR = "ERROR",
}
